import { Component, OnInit } from '@angular/core';
import { DataEntry } from 'src/app/shared/data-entry.interface';
import { CommonService } from '../common.service';
import { DataproviderService } from 'src/app/dataprovider.service';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  host: {
    class: 'center-route-content'
  }
})
export class SwitchComponent implements OnInit {
  title:    string = "b2c.IDS_SWITCH";
  subtitle: string = "b2c.IDS_SWITCH_SUB";
  question: string = "b2c.IDS_SWITCH_QUE";
  activePage: string = "switch";
  nextPage: string = "time";
  dataEntries: DataEntry[] = [];

  constructor(
    private cs: CommonService,
    private ds: DataproviderService
  ) {
    this.cs.setParams(this.title, this.subtitle, this.question, this.activePage, this.nextPage, false, true, false, true);
  }

  ngOnInit() {
    this.dataEntries = this.ds.getDefaultSwitches();
  }

  dataEntriesUpdate(idSelected: number){
    /* single selection */
    for (let data of this.dataEntries) {
      if ( data["ID"] == idSelected ) { data.checked = true; } else { data.checked = false; }
    }
    this.cs.updateNextBtn(true);
  }

  onSelectorClicked(idSelected: number){
    this.dataEntriesUpdate(idSelected);
    //Simone: ho corretto la funzione setSwitch che non poteva ricevere un numero ma voleva uno switch....controllare se va bene usare setSwitchByID anche qui
    this.ds.setSwitchByID(idSelected);
  }

}
